import React from 'react';

/** Original source artwork, served locally. See docs/brand-assets.md. */
export const CryptoIcon: React.FC<{
  readonly coin: 'bitcoin' | 'tether' | 'ethereum';
  readonly size?: number;
}> = ({ coin, size = 24 }) => (
  <img
    className="crypto-icon"
    src={`/${coin}.svg`}
    width={size}
    height={size}
    alt={coin === 'bitcoin' ? 'Bitcoin' : coin === 'ethereum' ? 'Ethereum' : 'Tether USDT'}
    draggable={false}
  />
);
